module.exports = __webpack_public_path__ + "static/media/na.347a6e25.svg";